export const getWindowWidth = () => {
  const { innerWidth: width } = window || { innerWidth: 1024 }
  return width
}
